// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Belarus */
const BY = /^(?:(?:2(?:5[5-79]|9[1-9])|(?:33|44)\d)\d{6})$/;

export default BY;
